import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatRelativeDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const diffMs = now - d;
  const day = 24 * 60 * 60 * 1000;
  const days = Math.floor(diffMs / day);
  if (days <= 0) return "today";
  if (days === 1) return "1d ago";
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
}

export const SOURCE_LABEL = {
  keynote: "Keynote",
  earnings_call: "SEC-Filed",
  podcast: "Podcast",
  interview: "Interview",
  youtube: "YouTube",
};

// Mirrors backend AFFILIATIONS — expert is a corporate insider of these tickers.
export const INSIDER_AFFILIATIONS = {
  "jensen-huang": ["NVDA"],
  "elon-musk": ["TSLA"],
  "michael-saylor": ["MSTR"],
  "alex-karp": ["PLTR"],
  "sanjay-mehrotra": ["MU"],
  "dylan-leclair": ["MTPLF"],
};

export function isInsider(expertId, ticker) {
  if (!expertId || !ticker) return false;
  return (INSIDER_AFFILIATIONS[expertId] || []).includes(ticker.toUpperCase());
}
